import { foot, px, type WorldObject } from './mapdef';

/** Interactive objects of the classroom package (ids prefixed, see mapdef ObjectId). */
export const OBJECTS_CLASSROOM: readonly WorldObject[] = [
  // School corridor: lost & found box by the counselling room, notice board by the library.
  { id: 'cls_lostBox', map: 'school', rect: foot(3, 13, 2, 8), solid: true, label: 'cls_lostBox', icon: '📦' },
  { id: 'cls_notice', map: 'school', rect: foot(38, 13, 3, 6), solid: true, label: 'cls_notice', icon: '📌' },
  // The yard: Xiaoqiang's ball, left between the two kids at recess.
  { id: 'cls_ball', map: 'town', rect: { x: px(42) + 2, y: px(15) - 4, w: 12, h: 6 }, solid: false, label: 'cls_ball', icon: '⚽', days: ['fri'], tall: 14 },
];
